import React, { Component } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { fetchShow } from 'ducks/shows';

class ShowSettingsPage extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: true };
  }

  componentDidMount() {
    const { showId } = this.props.params;

    this.props.fetchShow(showId).then(() => this.setState({ loading: false }));
  }

  render() {
    const { children } = this.props;
    const { loading } = this.state;

    if (loading) {
      return null;
    }

    return <>{children}</>;
  }
}

ShowSettingsPage.propTypes = {
  children: T.node.isRequired,
  fetchShow: T.func.isRequired,
  params: T.object.isRequired,
};

export default connect(
  undefined,
  { fetchShow }
)(ShowSettingsPage);
